module.exports = __webpack_public_path__ + "img/logo.1efb68dc.png";